import { Card, CardContent } from '@/components/ui/card';
import { Users, Target, Shield, Award } from 'lucide-react';
import { AboutPageSEO } from '@/components/SEOHead';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="about-page">
      {/* SEO Head */}
      <AboutPageSEO />
      
      {/* Hero */}
      <section className="bg-emerald-800 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
            Hakkımızda
          </h1>
          <p className="text-xl text-emerald-100 max-w-2xl mx-auto">
            Türkiye'nin en güvenilir spor tesisi kiralama platformu
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Mission */}
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Misyonumuz</h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              tesiskirala.com olarak, sporseverlerin kaliteli tesislere hızlı ve kolay 
              erişimini sağlamayı hedefliyoruz. Halı sahadan kapalı spor salonlarına, 
              tüm spor tesislerini tek bir platformda buluşturarak, spor yapmayı 
              herkes için daha erişilebilir hale getiriyoruz.
            </p>
          </div>

          {/* Values */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <Card className="text-center p-6 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <Users className="w-7 h-7 text-emerald-700" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">Topluluk Odaklı</h3>
                <p className="text-sm text-slate-600">
                  Sporseverler ve tesis sahiplerini bir araya getiriyoruz
                </p>
              </CardContent>
            </Card>

            <Card className="text-center p-6 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <Target className="w-7 h-7 text-emerald-700" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">Kolay Kullanım</h3>
                <p className="text-sm text-slate-600">
                  Saniyeler içinde tesis bul ve rezervasyon yap
                </p>
              </CardContent>
            </Card>

            <Card className="text-center p-6 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-7 h-7 text-emerald-700" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">Güvenilir</h3>
                <p className="text-sm text-slate-600">
                  Onaylı tesisler ve güvenli ödeme sistemi
                </p>
              </CardContent>
            </Card>

            <Card className="text-center p-6 hover:shadow-lg transition-shadow">
              <CardContent className="pt-6">
                <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <Award className="w-7 h-7 text-emerald-700" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">Kalite</h3>
                <p className="text-sm text-slate-600">
                  En iyi tesisler, en uygun fiyatlar
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Stats */}
          <div className="bg-emerald-800 rounded-3xl p-8 md:p-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <p className="text-4xl md:text-5xl font-bold text-lime-300">500+</p>
                <p className="text-emerald-100 mt-2">Aktif Tesis</p>
              </div>
              <div>
                <p className="text-4xl md:text-5xl font-bold text-lime-300">50K+</p>
                <p className="text-emerald-100 mt-2">Mutlu Kullanıcı</p>
              </div>
              <div>
                <p className="text-4xl md:text-5xl font-bold text-lime-300">81</p>
                <p className="text-emerald-100 mt-2">İl</p>
              </div>
              <div>
                <p className="text-4xl md:text-5xl font-bold text-lime-300">100K+</p>
                <p className="text-emerald-100 mt-2">Rezervasyon</p>
              </div>
            </div>
          </div>

          {/* Team Note */}
          <div className="mt-16 text-center">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Ekibimiz</h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Genç ve dinamik ekibimiz, spor tutkusunu teknoloji ile birleştirerek 
              Türkiye'nin en iyi tesis kiralama deneyimini sunmak için çalışıyor. 
              Siz de aramıza katılın!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
